<template>
  <div class="mx-auto text-center">
    <SpinningLoader :pending="true" />
  </div>
</template>
  
<script setup>
import { useAuth0 } from "@auth0/auth0-vue";

import SpinningLoader from "../components/SpinningLoader.vue";

const { logout: auth0Logout } = useAuth0();

const logout = function () {
  auth0Logout({ returnTo: window.location.origin })
}

logout()
</script>